// extracted by mini-css-extract-plugin
export var subtitle = "_bs-2";
export var title = "_bs-0";
export var titleNoWrap = "_bs-1";